// Drag-and-drop handlers for inbox triage zones (duration / project / context).
import { getDurationMinutesForZone } from '@/features/organize/utils/inboxTriageUtils';
import { applyDurationReviewToUpdate } from '@/features/tasks/utils/data/durationReviewUtils';

export const applyDurationDrop = (overId, taskId, user, updateTask) => {
  const duration = getDurationMinutesForZone(overId);
  if (duration !== null && duration !== undefined) {
    // Explicit requireTimeReview: false so the task leaves the Tijd triage group
    // even if a caller bypasses taskMutations.updateTask.
    updateTask(taskId, applyDurationReviewToUpdate({ duration }), user.uid);
  }
};

export const applyProjectDrop = (overId, taskId, user, updateTask) => {
  if (!overId.startsWith('triage-project-')) return;
  const projectId = overId.replace('triage-project-', '');
  if (projectId !== 'untagged')
    updateTask(taskId, { projects: [projectId] }, user.uid);
};

export const applyContextDrop = (overId, taskId, user, updateTask) => {
  if (!overId.startsWith('triage-context-')) return;
  const contextId = overId.replace('triage-context-', '');
  if (contextId !== 'untagged')
    updateTask(taskId, { contexts: [contextId] }, user.uid);
};

export const DROP_HANDLERS_BY_GROUP_KEY = {
  duration: applyDurationDrop,
  project: applyProjectDrop,
  context: applyContextDrop,
};
